export default {
    SearchConfiguration: {
        Code: '编码',
        Index: '索引',
        start: '生效开始时间',
        end: '生效结束时间',
        Description: '描述',
        New: '新 建',
        delete: '确认删除选中行？',
        add: {
            Query: '查询',
            Custom: '自定义参数',
            Test: '测 试',
            enter: '请输入',
            Return: '返回结果：',
            Execute: '执 行',
            entercode: '请输入编码',
            enterindex: '请输入索引',
            enterstart: '请输入生效开始时间',
            enterend: '请输入生效结束时间',
            successfully: '修改成功',
            added: '添加成功',
            enterJSON: '请输入JSON类型的自定义数据',
        }
    },
};
